import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history/Middle_Ages_-_Feudal_Japan.png';

function HistoryPageJapan() {
  return (
    <TopicPage
      topicKey="Feudal Japan"
      title="History: Feudal Japan"
      backgroundImage={bg}
      startRoute="/History-Feudal-Japan-Go"
      scrollLabels={[
        "Samurai and Daimyo",
        "Shogunate Rule",
        "Culture and Isolation",
      ]}
                    backRoute="/history-Middle-Ages"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageJapan;   